
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { IExpiredPracticeDetailForm } from "../../../models/models";
import { useFormContext } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { closeSelectedPractices } from "../../../services/http.services";
import { useContext, useState } from "react";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import CustomLoader from "../../../../../util/component/CustomLoader";
import ExpiredCustomDialog from "../../../common/dialog/ExpiredCustomDialog";
import Typography from "@mui/material/Typography";
import { useSetRecoilState } from "recoil";
import { practiceDetail } from "../../../state";
import { setSnackbar } from "../../../../../util/state/globalAction";

const CloseActionButton = () => {

    const theme = useTheme();
    const {t} = useTranslation(['expiredManagement']);
    const { dispatchGlobalData } = useContext(GlobalContext);

    const expiredPracticeDetailForm = useFormContext<IExpiredPracticeDetailForm>();

    const [openDialog, setOpenDialog] = useState(false);

    const setPracticeDetail = useSetRecoilState(practiceDetail);

    const handleSetAsClose = (event: React.MouseEvent) => {
        event.stopPropagation();

        setOpenDialog(true); 
    }

    const onConfirm = () => {
        const expiredcode = expiredPracticeDetailForm.getValues("detail.expiredCode");
        if(!!expiredcode)
            closePracticesMutation.mutate([expiredcode]);

        setOpenDialog(false);
    }

    const onClose = () => {
        setOpenDialog(false);
    }

    const closePracticesMutation = useMutation({
        mutationFn: (request: string[]) => {
            return closeSelectedPractices(request);
        },
        onSuccess: (response) => {

            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t('common.message.success'),
                        type: snackbarTypes.success,
                        show: true,
                        autoClose: true,
                    }
                }
            });

            setPracticeDetail(response.data); 

        },
        onError: (error: any) => {

            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t(`common.message.error.close.${error?.response?.status}`, t('common.message.error.tryLater')),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });

        }
    });

    return (
        <>
            <Button sx={{ml: theme.spacing(1)}} onClick={handleSetAsClose}>
                {t('closeExpired.button.closeExpired')}
            </Button>

            <ExpiredCustomDialog 
                open={openDialog} 
                contentDescription={
                    <Typography color="primary" variant="body1">
                        {t('closeExpired.dialog.message')}
                    </Typography>
                }
                buttonCloseDescription={t('common.button.cancel')}
                buttonConfirmDescription={t('common.button.confirm')}
                onClose={onClose}
                onConfirm={onConfirm}           
            />

            <CustomLoader loading={closePracticesMutation.isLoading} />
        </>
    )
}

export default CloseActionButton;